import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import {
    AncillaryItem,
    UpsertAncillaryRequest,
    UpdateAncillaryStatusRequest,
    AncillaryCategory,
    FareType
} from '../interfaces/ancillary.interface';
import { AncillaryMarkupItem, UpsertAncillaryMarkupRequest } from '../interfaces/ancillary-markup.interface';

@Injectable({
    providedIn: 'root'
})
export class AncillaryService {
    http = inject(HttpClient);
    baseUrl = environment.apiUrl + '/ancillary';

    getAncillaries(): Observable<AncillaryItem[]> {
        const apiUrl = `${this.baseUrl}`;
        return this.http.get<AncillaryItem[]>(apiUrl);
    }

    createAncillary(request: UpsertAncillaryRequest) {
        const apiUrl = `${this.baseUrl}`;
        return this.http.post(apiUrl, request);
    }

    updateAncillary(id: number, request: UpsertAncillaryRequest) {
        const apiUrl = `${this.baseUrl}/${id}`;
        return this.http.put(apiUrl, request);
    }

    updateAncillaryStatus(id: number, request: UpdateAncillaryStatusRequest) {
        const apiUrl = `${this.baseUrl}/${id}/status`;
        return this.http.patch(apiUrl, request);
    }

    deleteAncillary(id: number) {
        const apiUrl = `${this.baseUrl}/${id}`;
        return this.http.delete(apiUrl);
    }

    getCategories(): Observable<AncillaryCategory[]> {
        const apiUrl = `${this.baseUrl}/categories`;
        return this.http.get<AncillaryCategory[]>(apiUrl);
    }

    getFareTypes(): Observable<FareType[]> {
        const apiUrl = `${this.baseUrl}/fare-types`;
        return this.http.get<FareType[]>(apiUrl);
    }

    getAncillaryMarkups(): Observable<AncillaryMarkupItem[]> {
        const apiUrl = `${this.baseUrl}/markups`;
        return this.http.get<AncillaryMarkupItem[]>(apiUrl);
    }

    createAncillaryMarkup(request: UpsertAncillaryMarkupRequest): Observable<AncillaryMarkupItem> {
        const apiUrl = `${this.baseUrl}/markups`;
        return this.http.post<AncillaryMarkupItem>(apiUrl, request);
    }

    updateAncillaryMarkup(id: number, request: UpsertAncillaryMarkupRequest): Observable<AncillaryMarkupItem> {
        const apiUrl = `${this.baseUrl}/markups/${id}`;
        return this.http.put<AncillaryMarkupItem>(apiUrl, request);
    }

    updateAncillaryMarkupStatus(id: number, active: boolean): Observable<AncillaryMarkupItem> {
        const apiUrl = `${this.baseUrl}/markups/${id}/status?active=${active}`;
        return this.http.patch<AncillaryMarkupItem>(apiUrl, null);
    }
}
